import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'm-hint',
  templateUrl: './hint.component.html',
  styleUrls: ['./hint.component.scss']
})
export class HintComponent implements OnInit {

  @Input() hint: string;

  constructor() { }

  ngOnInit() {
  }

}
